import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    border-radius: 16px 16px 0 0;
    padding: 64px 32px 32px 32px;
    background: linear-gradient(90deg, #C7FFC3 0%, rgba(199, 255, 195, 0) 20%, rgba(199, 255, 195, 0) 70%, #A0D0D1 100%);

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      padding: 48px 16px 16px 16px;
    }
    
    @media (max-width: ${theme.v3.breakpoints.sm}) {
      flex-direction: column;
    }
  `}
`;

export const LogoAdapter = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin: 0 auto;
    }
  `}
`;

export const Image = styled.img`
  ${({ theme }) => css`
    width: 150px;
    height: 150px;
    object-fit: cover;
    object-position: top center;
    margin-bottom: -32px;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      margin-bottom: -32px;
      height: 124px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin-bottom: 0px;
      height: 100px;
    }
  `}
`;

export const ContentAdapter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 24px;
  gap: 8px;
`;

export const Title = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.brand.snappyBlue[10]};
    font-size: ${theme.v3.font.sizes['1xlarge']};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    margin: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v3.font.sizes.mini};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    background: linear-gradient(112deg, ${theme.v3.colors.brand.snappyBlue[10]} 14.84%, ${theme.v3.colors.brand.snappyBlue[40]} 85.61%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0;
  `}
`;

export const SelectAdapter = styled.div`
  ${({ theme }) => css`
    padding: 12px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: auto;
    gap: 8px;
    width: 100%;
    max-width: 500px;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 20%, rgba(255, 255, 255, 0) 80%, rgba(255, 255, 255, 0.40) 100%);
    border-radius: 8px;

    @media (max-width: ${theme.v3.breakpoints.lg}) {
      max-width: 300px;
    }

    @media (max-width: ${theme.v3.breakpoints.sm}) {
      margin-left: 0;
      max-width: 100%;
      margin-top: 16px;
      align-items: center;
      text-align: center;
    }
  `}
`;

export const SelectLabel = styled.p`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    margin: 0;
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
  `}
`;

export const ProBadge = styled.span`
  ${({ theme }) => css`
    background: linear-gradient(90deg, #0171AF 0%, #A0D0D1 100%);
    color: ${theme.v3.colors.brand.snappyBlue[98]};
    font-size: 10px;
    font-weight: ${theme.v3.font.weights.bold};
    line-height: ${theme.v3.font.lineHeight.comfortable};
    padding: 4px 6px;
    border-radius: 8px;
    margin-left: 8px;
  `}
`;

export const MaxWrapper = styled.div`
  display: flex;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SinglePlanLabel = styled.span`
  ${({ theme }) => css`
    color: ${theme.v3.colors.neutral[40]};
    font-size: ${theme.v3.font.sizes.small};
    font-weight: ${theme.v3.font.weights.medium};
    line-height: ${theme.v3.font.lineHeight.relaxed};
    background: ${theme.v3.colors.brand.snappyBlue[98]};
    border-radius: 8px;
    padding: 12px 16px;
  `}
`;
